module.exports = function () {
    function resizeHeight() {
        $('.slidersection').height($('.slidersection .text-container').outerHeight() - 300);
    }

    var duration = 5000;

    var slideEl = $('.slider');
    var slideWidth;
    var slideCount;
    var interval;

    var startX;
    var pos;

    var cancelSwipeEnd = false;

    var swiping = false;


    $(document).ready(function () {

        if (slideEl.length === 0) {
            return;
        }

        initSlider();
        interval = setInterval(function () {
            slideTo((currentSlide + 1) % (slideCount + 1));
        }, duration);

        $('#sliderleft').click(function () {
            slideRight();
        })
        $('#sliderright').click(function () {
            slideLeft();
        });

        slideEl.find('a').click(function(ev) {
            if (swiping) {
                ev.preventDefault();
            }
        })

        var hammer = new Hammer($('.slidersection').get(0));
        hammer.on('pan', function (ev) {
            swipe(ev);
        });
        hammer.on('panend', function (ev) {
            if (!cancelSwipeEnd) {
                swipeEnd(ev);
            }
            cancelSwipeEnd = false;
        });
        hammer.on('swiperight', function (ev) {
            cancelSwipeEnd = true;
            slideLeft();
            startX = undefined;
            pos = undefined;
        });
        hammer.on('swipeleft', function (ev) {
            cancelSwipeEnd = true;
            slideRight();
            startX = undefined;
            pos = undefined;
        });
    });

    $(window).resize(function () {
        if (slideEl.length === 0) {
            return;
        }

        initSlider();
    });

    var currentSlide = 0;

    function initSlider() {
        resizeHeight();
        slideWidth = slideEl.width();
        slideCount = slideEl.find('.slide').length - 1;
    }

    function slideRight() {
        slideTo(currentSlide + 1);
    }

    function slideLeft() {
        slideTo(currentSlide - 1);
    }

    function limitCount(count) {
        return Math.max(0, Math.min(count, slideCount));
    }

    function swipe(ev) {
        if (cancelSwipeEnd) {
            return;
        }
        swiping = true;
        slideEl.stop();
        clearInterval(interval);
        var delta = ev.deltaX
        if (!startX) {
            startX = delta;
        }

        pos = (0 - (currentSlide * slideWidth)) + delta;

        slideEl.css({
            left: pos
        })

        if (Math.abs(ev.overallVelocityX) > 4) {
            pos = 0 - ((currentSlide + -1 * Math.sign(ev.overallVelocityX)) * slideWidth)
        }
    }

    function swipeEnd(ev) {
        startX = undefined;

        currentSlide = Math.max(0, Math.min(Math.round(-pos / slideWidth), (slideCount)));

        slideTo(currentSlide);



        pos = undefined;
    }

    function slideTo(index) {
        clearInterval(interval);
        currentSlide = limitCount(index);
        slideEl.stop();
        slideEl.animate({
            left: currentSlide * -100 + '%'
        }, 200, function () {
            swiping = false;
            interval = setInterval(function () {
                slideTo((currentSlide + 1) % (slideCount + 1));
            }, duration);
        })
    }
}